import abTests from 'frontend/shared/javascripts/modules/ab_tests'

// Whether Convert put the visitor into the variation of the A/B test user_home_hub. Only known in the
// browser, so the layout starts watching on mount.
export const userHomeHub = $state({ variation: false })

export function watchUserHomeHub(): () => void {
  return abTests.onVariant('user_home_hub', (variant) => {
    userHomeHub.variation = variant === 'b'
  })
}
